<template>
  <div class="myTeamInvite">
    <div class="img_box">
      <img src="../../assets/images/banner.jpg" />
    </div>
    <p class="name">{{ $route.query.nickname }}</p>
    <p>邀请你加入团队</p>
    <p class="team">{{ $route.query.title }}</p>
    <p class="tip">共享团队得产品视频、文章</p>
    <div class="btn" v-if="showBtn" @click="share">发送邀请</div>
    <div class="btn" v-if="!showBtn" @click="invite">
      {{ have ? "进入团队" : "确认邀请" }}
    </div>
    <div class="share" v-if="showShare">
      <img src="../../assets/images/lc_team_share.png" />
      <p>发送邀请页面给朋友</p>
    </div>
  </div>
</template>

<script>
import { Icon, Toast } from "vant";
import { getUser } from "@api/user";
import { postShare, getWechatConfig, getTeamList } from "@api/public";
import wx from "weixin-js-sdk";
export default {
  name: "MyTeamInvite",
  components: {
    [Icon.name]: Icon,
  },
  data() {
    return {
      showBtn: true,
      showShare: false,
      teamList: "",
      have: false,
    };
  },
  mounted() {
    const that = this;
    getUser().then((res) => {
      if (res.data.uid == this.$route.query.uid) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    });
    that.getTeamList();
    getWechatConfig().then((data) => {
      wx.config({
        debug: false,
        appId: data.data.appId,
        timestamp: data.data.timestamp,
        timestamp: data.data.timestamp,
        nonceStr: data.data.nonceStr,
        signature: data.data.signature,
        jsApiList: [
          "checkJsApi",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "hideMenuItems",
          "showMenuItems",
          "hideAllNonBaseMenuItem",
          "showAllNonBaseMenuItem",
          "translateVoice",
          "startRecord",
          "stopRecord",
          "onRecordEnd",
          "playVoice",
          "pauseVoice",
          "stopVoice",
          "uploadVoice",
          "downloadVoice",
          "chooseImage",
          "previewImage",
          "uploadImage",
          "downloadImage",
          "getNetworkType",
          "openLocation",
          "getLocation",
          "hideOptionMenu",
          "showOptionMenu",
          "closeWindow",
          "scanQRCode",
          "chooseWXPay",
          "openProductSpecificView",
          "addCard",
          "chooseCard",
          "openCard",
        ],
        openTagList: ["wx-open-launch-weapp"],
      });
      wx.ready(function() {
        //config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
        wx.updateAppMessageShareData({
          title:
            that.$route.query.nickname + "邀请您加入" + that.$route.query.title, // 分享标题
          desc: "期待您的加入，美美获客精准锁定客户。", // 分享描述
          link: "https://beauty.yanjiusuo.xyz" + that.$route.fullPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://jd-medical-beauty.oss-cn-chengdu.aliyuncs.com/product/dc7b420220411105559327.png", // 分享图标
          success: function() {
            // 设置成功
          },
        });
        wx.onMenuShareAppMessage({
          title:
            that.$route.query.nickname + "邀请您加入" + that.$route.query.title, // 分享标题
          desc: "期待您的加入，美美获客精准锁定客户。", // 分享描述
          link: "https://beauty.yanjiusuo.xyz" + that.$route.fullPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://jd-medical-beauty.oss-cn-chengdu.aliyuncs.com/product/dc7b420220411105559327.png", // 分享图标
          success: function() {
            // 设置成功
          },
        });
        wx.updateTimelineShareData({
          title:
            that.$route.query.nickname + "邀请您加入" + that.$route.query.title, // 分享标题
          link: "https://beauty.yanjiusuo.xyz" + that.$route.fullPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://jd-medical-beauty.oss-cn-chengdu.aliyuncs.com/product/dc7b420220411105559327.png", // 分享图标
          success: function() {
            // 设置成功
          },
        });
        wx.onMenuShareTimeline({
          title:
            that.$route.query.nickname + "邀请您加入" + that.$route.query.title, // 分享标题
          link: "https://beauty.yanjiusuo.xyz" + that.$route.fullPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://jd-medical-beauty.oss-cn-chengdu.aliyuncs.com/product/dc7b420220411105559327.png", // 分享图标
          success: function() {
            // 设置成功
          },
        });
      });
      wx.error(function(res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    });
  },
  methods: {
    /**
     * 获取团队列表
     */
    getTeamList() {
      getTeamList().then((res) => {
        this.teamList = res.data;
        let have = this.teamList.find((item) => {
          if (item.id == this.$route.query.id) {
            return item;
          }
        });
        if (have == undefined) {
          this.have = false;
        } else {
          this.have = true;
        }
      });
    },
    share() {
      this.showShare = true;
      setTimeout(() => {
        this.showShare = false;
      }, 2000);
    },
    invite() {
      if (this.have) {
        this.$router.push({
          path: "/my/team",
        });
        return;
      }
      postShare({
        key: this.$route.query.key,
        inviter_uid: this.$route.query.uid,
      })
        .then((res) => {
          if (res.status == 200) {
            Toast({ message: "加入成功" });
            this.$router.replace({
              path: "/my/team",
              query: {
                id: this.$route.query.id,
              },
            });
          } else {
            Toast({ message: res.msg });
            // this.$router.replace({
            //   path: "/",
            // });
          }
        })
        .catch((err) => {
          Toast({ message: err.msg });
          // this.$router.replace({
          //   path: "/",
          // });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.myTeamInvite {
  text-align: center;
  .img_box {
    width: 1rem;
    height: 1rem;
    overflow: hidden;
    border-radius: 50%;
    font-size: 0;
    margin: 0 auto;
    margin-top: 1rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .name {
    font-size: 0.32rem;
    font-weight: bold;
    margin: 0.4rem 0;
  }
  .team {
    font-weight: bold;
    margin: 0.4rem 0;
    color: #ff410a;
  }
  .tip {
    color: #999999;
  }
  .btn {
    width: 50%;
    margin-top: 1rem;
    display: inline-block;
    color: #ffffff;
    background: #ff410a;
    line-height: 0.8rem;
    border-radius: 0.1rem;
    font-size: 0.26rem;
  }
  .share {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    img {
      width: 1rem;
      float: right;
      margin-right: 0.2rem;
      margin-top: 0.1rem;
    }
    p {
      color: #ffffff;
      font-weight: bold;
      font-size: 0.32rem;
      clear: both;
      text-align: right;
      padding-right: 1rem;
      margin-top: 1.2rem;
      letter-spacing: 0.02rem;
    }
  }
}
</style>
